import { Length, NullLength, pickFirst } from '../../values/index.js';
export const Props = (props = {}) => ({
    minWidth: [NullLength(props.minWidth), Length(props.minWidth)].reduce(pickFirst),
    maxWidth: [NullLength(props.maxWidth), Length(props.maxWidth)].reduce(pickFirst),
    minHeight: [NullLength(props.minHeight), Length(props.minHeight)].reduce(pickFirst),
    maxHeight: [NullLength(props.maxHeight), Length(props.maxHeight)].reduce(pickFirst)
});
export const validate = () => true;
export const fix = (props, styles) => props;
export const type = 'dimensions';
export const label = 'Dimensions';
export const property = 'dimensionIds';
export const category = 'aspect';
export const summarize = (props, styles, formId) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    return ((_a = props.minWidth) === null || _a === void 0 ? void 0 : _a.value) || ((_b = props.maxWidth) === null || _b === void 0 ? void 0 : _b.value) || ((_c = props.minHeight) === null || _c === void 0 ? void 0 : _c.value) || ((_d = props.maxHeight) === null || _d === void 0 ? void 0 : _d.value)
        ? ((_e = props.minWidth) === null || _e === void 0 ? void 0 : _e.value) === ((_f = props.maxWidth) === null || _f === void 0 ? void 0 : _f.value) && ((_g = props.minHeight) === null || _g === void 0 ? void 0 : _g.value) === ((_h = props.maxHeight) === null || _h === void 0 ? void 0 : _h.value)
            ? `${props.minWidth ? props.minWidth.value + props.minWidth.unit : 'Auto'} × ${props.minHeight ? props.minHeight.value + props.minHeight.unit : 'Auto'}`
            : 'Advanced'
        : 'Auto';
};
//# sourceMappingURL=dimensions.js.map